
import { Product } from "@/types/product";

interface AvailableForSectionProps {
  product: Product;
}

export default function AvailableForSection({ product }: AvailableForSectionProps) {
  // Calculate items per row to ensure max 3 rows
  const totalItems = product.availableFor.length;
  const itemsPerRow = Math.ceil(totalItems / 3);

  return (
    <section className="mb-8">
      <div className="p-4 bg-gray-50 rounded-lg">
        <h3 className="font-semibold text-lg mb-4">Available For</h3>
        <div className="flex flex-wrap gap-1">
          {product.availableFor.map((company, index) => (
            <span
              key={index}
              className="text-xs text-gray-700 px-2 py-1 bg-white rounded border border-gray-200 
                transition-all duration-200 ease-in-out 
                hover:scale-105 hover:bg-gray-50 hover:shadow-md hover:border-gray-300"
            >
              {company}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
